/**
 * Determines if it is client side
 */
export const useIsClient = () => typeof window !== 'undefined'
